import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initPWAInstallListener } from "./utils/pwaInstallManager";

// Initialize PWA install listener EARLY before React renders
// This ensures we catch the beforeinstallprompt event reliably
initPWAInstallListener();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA (installable app, offline support)
serviceWorkerRegistration.register();
